/** Stable Firestore doc for website/app content (NOT tied to any admin Auth UID). */
export const ADMIN_CONTENT_DOC_ID = "app_content";

/** Fields that indicate a legacy admin/{uid} doc holds site content. */
const CONTENT_HINT_KEYS = [
  "about_us",
  "faq",
  "eula",
  "privacy_policy",
  "terms_and_conditions",
  "terms_conditions",
  "cta_content",
  "social_links",
  "bodyContent",
  "contact",
];

export function looksLikeContentDoc(data) {
  if (!data || typeof data !== "object") return false;
  return CONTENT_HINT_KEYS.some((key) => data[key] != null);
}

/**
 * Strip Firestore doc id / auth-only noise before writing content.
 */
export function contentFieldsOnly(data) {
  if (!data) return {};
  const {
    id,
    role,
    isAdmin,
    admin_email,
    granted_at,
    granted_by,
    ...rest
  } = data;
  return rest;
}
